import * as React from "react";

function SvgReply(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 18"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M24 17.96S21 5.23 9.33 5.23V-.04L0 8.62l9.33 8.78v-5.71c6.35-.01 11.36.55 14.67 6.27z" />
    </svg>
  );
}

const MemoSvgReply = React.memo(SvgReply);
export default MemoSvgReply;
